export default __webpack_public_path__ + "static/media/material-playlist-add.80aa4a3a.svg";